/*
 * hp-hover-zoom.js
 * ---------------------------------------------------------------------------
 * Lufian-style hover zoom for the product detail gallery.
 *
 * Masaustunde urun gorseli uzerinde mouse gezdirildiginde gorselin uzerinde bir
 * "lens" (secim kutusu) cikar ve galerinin sagindaki panelde o bolgenin buyutulmus
 * hali gosterilir. Gorsele tiklandiginda tema kendi zoom/lightbox ekranini acmaya
 * devam eder (bu script tiklamaya hic karismaz).
 *
 * Video / 3D model / harici video slaytlarinda zoom CALISMAZ.
 *
 * Kullanim:
 *   HPHoverZoom.init({
 *     root: '#SlidesCon',                    // galeri kok elemani (selector veya element)
 *     item: '.product-media-image',          // her bir medya slaytinin selector'u
 *     boundary: '.product-main-media-section' // panelin hizalanacagi kolon (opsiyonel)
 *   });
 */
(function (window, document) {
  'use strict';

  if (window.HPHoverZoom) return;

  var DEFAULTS = {
    root: null,
    item: null,
    image: 'img',
    boundary: null,
    zoom: 2.35,
    // Bazi temalarda bir slayt digerlerinden genis gosterilir (orn. AK'de medya
    // sayisi tekse ilk gorsel 2 kolona yayilir). O slayt zaten buyuk gorundugu
    // icin ayni zoom orani fazla geliyor; genisligine gore yumusatilir.
    minZoom: 1.75,
    gap: 16,
    margin: 16,
    // Panel olcusu slaytin genisligine gore DEGISMEZ; hedef genislik budur.
    // (Onceden slayt genisligiyle orantiliydi: AK'de 2'li gridde dar, tam
    // genislikteki slaytta genis acilmasina yol aciyordu.)
    panelWidth: 360,
    minPanelWidth: 260,
    maxPanelHeight: 480,
    mediaQuery: '(min-width: 1068px)',
    // Bu selector'lardan biri sayfada aktifse (lightbox acikken) hover zoom devre disi
    blockedBy: '.pswp--open, .modal.modal-zoomed.open',
    blockedBodyClass: 'body-lock-scroll'
  };

  // Video / model / harici video iceren slaytlar atlanir.
  var NON_ZOOMABLE = '.product-media-no-zoom, .hp-no-zoom, video, iframe, model-viewer, product-model, .product-single__media-native-video, .product-single__media-external-video, .product-single__media-model, .product-media-external-media, .product-media-model';

  var SHOPIFY_CDN = /(cdn\.shopify\.com|\/cdn\/shop\/)/;
  var WIDTH_STEPS = [800, 1200, 1600, 2048, 2560, 3200];

  function toElement(value, context) {
    if (!value) return null;
    if (typeof value === 'string') return (context || document).querySelector(value);
    return value.nodeType === 1 ? value : null;
  }

  function clamp(value, min, max) {
    if (max < min) return min;
    return value < min ? min : value > max ? max : value;
  }

  /*
   * Orijinal gorselin gercek genisligi.
   * DIKKAT: img.naturalWidth o an YUKLENMIS varyantin genisligidir (srcset yuzunden
   * cogu zaman 600-900px), orijinalin degil. Tavan olarak onu kullanmak paneli
   * dusuk cozunurlukte birakip bulanikliga yol aciyordu. Once srcset'teki en buyuk
   * "w" degerine, sonra lightbox linkindeki data-w'ye bakiyoruz.
   */
  function sourceWidthLimit(img) {
    var limit = 0;

    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    srcset.split(',').forEach(function (candidate) {
      var match = candidate.trim().match(/\s(\d+)w$/);
      if (match) limit = Math.max(limit, parseInt(match[1], 10));
    });

    if (!limit) {
      var parent = img.closest('[data-w]') || (img.parentNode && img.parentNode.querySelector ? img.parentNode.querySelector('[data-w]') : null);
      if (parent) limit = parseInt(parent.getAttribute('data-w'), 10) || 0;
    }

    if (!limit) limit = img.naturalWidth || 0;
    return limit;
  }

  /* Shopify CDN url'ini istenen genislikte yeniden uretir. */
  function highResSource(img, targetWidth) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    if (!SHOPIFY_CDN.test(src)) return src;

    var width = WIDTH_STEPS[WIDTH_STEPS.length - 1];
    for (var i = 0; i < WIDTH_STEPS.length; i++) {
      if (WIDTH_STEPS[i] >= targetWidth) {
        width = WIDTH_STEPS[i];
        break;
      }
    }

    var limit = sourceWidthLimit(img);
    if (limit && limit < width) width = limit;

    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.href;
    } catch (error) {
      return src;
    }
  }

  /*
   * object-fit degerini hesaba katarak gorselin ekranda gercekten kapladigi
   * alani (viewport koordinatlarinda) dondurur.
   */
  function renderedRect(img) {
    var box = img.getBoundingClientRect();
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    var width = box.width;
    var height = box.height;

    if (nw && nh) {
      var fit = window.getComputedStyle(img).objectFit;
      var scale = 0;
      if (fit === 'contain' || fit === 'scale-down') {
        scale = Math.min(box.width / nw, box.height / nh);
        if (fit === 'scale-down') scale = Math.min(scale, 1);
      } else if (fit === 'cover') {
        scale = Math.max(box.width / nw, box.height / nh);
      }
      if (scale > 0) {
        width = nw * scale;
        height = nh * scale;
      }
    }

    return {
      left: box.left + (box.width - width) / 2,
      top: box.top + (box.height - height) / 2,
      width: width,
      height: height,
      box: box
    };
  }

  function HoverZoom(options) {
    this.options = {};
    for (var key in DEFAULTS) {
      this.options[key] = options && options[key] !== undefined ? options[key] : DEFAULTS[key];
    }

    this.root = toElement(this.options.root);
    if (!this.root || !this.options.item) return;

    this.mql = window.matchMedia(this.options.mediaQuery);
    this.active = null;
    this.pointer = null;
    this.frame = null;
    this.loader = null;

    this.onPointerOver = this.onPointerOver.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerOut = this.onPointerOut.bind(this);
    this.onReposition = this.onReposition.bind(this);
    this.onEnvironmentChange = this.onEnvironmentChange.bind(this);

    this.root.addEventListener('pointerover', this.onPointerOver, { passive: true });
    this.root.addEventListener('pointermove', this.onPointerMove, { passive: true });
    this.root.addEventListener('pointerout', this.onPointerOut, { passive: true });
    // Mobilde dokunmatik kaydirmayi yavaslatmamasi icin passive.
    window.addEventListener('scroll', this.onReposition, { capture: true, passive: true });
    window.addEventListener('resize', this.onEnvironmentChange);
    if (this.mql.addEventListener) {
      this.mql.addEventListener('change', this.onEnvironmentChange);
    } else if (this.mql.addListener) {
      this.mql.addListener(this.onEnvironmentChange);
    }
  }

  HoverZoom.prototype.isEnabled = function () {
    if (!this.mql.matches) return false;
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return false;
    if (this.options.blockedBodyClass && document.body.classList.contains(this.options.blockedBodyClass)) return false;
    if (this.options.blockedBy && document.querySelector(this.options.blockedBy)) return false;
    return true;
  };

  /* Slayt zoom'lanabilir mi? (video / model / gorselsiz slayt degilse) */
  HoverZoom.prototype.resolveTarget = function (eventTarget) {
    if (!eventTarget || !eventTarget.closest) return null;
    var item = eventTarget.closest(this.options.item);
    if (!item || !this.root.contains(item)) return null;
    if (item.querySelector(NON_ZOOMABLE) || item.matches(NON_ZOOMABLE)) return null;

    var image = item.querySelector(this.options.image);
    if (!image || !image.complete || !image.naturalWidth) return null;
    return { item: item, image: image };
  };

  HoverZoom.prototype.onPointerOver = function (event) {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') return;
    if (!this.isEnabled()) return;

    var target = this.resolveTarget(event.target);
    if (!target) {
      if (this.active) this.close();
      return;
    }
    if (this.active && this.active.item === target.item) return;

    this.open(target);
    this.pointer = { x: event.clientX, y: event.clientY };
    this.update();
  };

  HoverZoom.prototype.onPointerMove = function (event) {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') return;
    if (!this.active) {
      this.onPointerOver(event);
      return;
    }
    if (!this.isEnabled()) {
      this.close();
      return;
    }
    this.pointer = { x: event.clientX, y: event.clientY };
    this.schedule();
  };

  HoverZoom.prototype.onPointerOut = function (event) {
    if (!this.active) return;
    // Slaytin icindeki bir elemana gecis yapiliyorsa kapatma.
    var next = event.relatedTarget;
    if (next && this.active.item.contains(next)) return;
    this.close();
  };

  HoverZoom.prototype.onReposition = function () {
    if (!this.active) return;
    this.schedule();
  };

  HoverZoom.prototype.onEnvironmentChange = function () {
    if (this.active) this.close();
  };

  HoverZoom.prototype.schedule = function () {
    if (this.frame) return;
    var self = this;
    this.frame = window.requestAnimationFrame(function () {
      self.frame = null;
      self.update();
    });
  };

  HoverZoom.prototype.buildLayers = function () {
    if (this.lens) return;

    this.lens = document.createElement('div');
    this.lens.className = 'hp-zoom-lens';

    this.panel = document.createElement('div');
    this.panel.className = 'hp-zoom-panel';
    this.panel.setAttribute('aria-hidden', 'true');

    document.body.appendChild(this.panel);
  };

  HoverZoom.prototype.open = function (target) {
    if (this.active) this.close();
    this.buildLayers();

    this.active = target;
    target.item.classList.add('hp-zoom-active');
    target.item.appendChild(this.lens);
    this.panel.classList.add('is-visible');

    // Galerideki en dar slayt referans alinir; genis slaytlarda zoom azaltilir.
    this.baseWidth = this.measureBaseWidth();

    var preview = target.image.currentSrc || target.image.src;
    this.panel.style.backgroundImage = 'url("' + preview + '")';
    this.loadHighRes(target.image);
  };

  /* Galerideki en dar medya slaytinin genisligi (referans olcu). */
  HoverZoom.prototype.measureBaseWidth = function () {
    var items = this.root.querySelectorAll(this.options.item);
    var min = 0;
    for (var i = 0; i < items.length; i++) {
      var width = items[i].getBoundingClientRect().width;
      if (width > 0 && (!min || width < min)) min = width;
    }
    return min;
  };

  /*
   * Slaytin genisligine gore yumusatilmis zoom orani.
   * Referans genislikteki slaytlar tam `zoom` degerini alir; daha genis
   * gosterilen slaytlarda oran karekokle azaltilir, `minZoom`un altina inmez.
   * Tum slaytlar esit genislikteyse (kigili) hicbir sey degismez.
   */
  HoverZoom.prototype.effectiveZoom = function (renderedWidth) {
    var opts = this.options;
    if (!this.baseWidth || !renderedWidth || renderedWidth <= this.baseWidth) return opts.zoom;
    return clamp(opts.zoom * Math.sqrt(this.baseWidth / renderedWidth), opts.minZoom, opts.zoom);
  };

  /* Panelde once mevcut gorsel, yuklenince yuksek cozunurluklu hali gosterilir. */
  HoverZoom.prototype.loadHighRes = function (image) {
    // Retina ekranlarda net gorunmesi icin cihaz piksel oranini da hesaba kat.
    var rect = image.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var source = highResSource(image, Math.round(rect.width * this.effectiveZoom(rect.width) * dpr));
    if (!source || source === (image.currentSrc || image.src)) return;

    var self = this;
    var loader = new Image();
    this.loader = loader;
    loader.onload = function () {
      if (self.loader !== loader || !self.active) return;
      self.panel.style.backgroundImage = 'url("' + source + '")';
    };
    loader.src = source;
  };

  HoverZoom.prototype.close = function () {
    if (this.frame) {
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    this.loader = null;

    if (this.active) {
      this.active.item.classList.remove('hp-zoom-active');
      this.active = null;
    }
    if (this.lens && this.lens.parentNode) this.lens.parentNode.removeChild(this.lens);
    if (this.panel) {
      this.panel.classList.remove('is-visible');
      this.panel.style.backgroundImage = '';
    }
    this.pointer = null;
  };

  /* Panelin ekrandaki yerini ve olcusunu hesaplar. */
  HoverZoom.prototype.measurePanel = function (itemRect) {
    var opts = this.options;
    var boundary = toElement(opts.boundary) || this.root;
    var boundaryRect = boundary.getBoundingClientRect();

    var spaceRight = window.innerWidth - boundaryRect.right - opts.gap - opts.margin;
    var spaceLeft = boundaryRect.left - opts.gap - opts.margin;
    var side = spaceRight >= spaceLeft ? 'right' : 'left';
    var space = Math.max(spaceRight, spaceLeft);
    if (space < opts.minPanelWidth) return null;

    // Genislik sabit hedeften, yukseklik slaytin en-boy oranindan turetilir.
    // Boylece 2'li gridde de 2 kolona yayilan slaytta da panel ayni olcude acilir.
    var width = Math.min(opts.panelWidth, space);
    var aspect = itemRect.width > 0 ? itemRect.height / itemRect.width : 1;
    var height = Math.min(
      width * aspect,
      opts.maxPanelHeight,
      window.innerHeight - opts.margin * 2
    );
    var left = side === 'right' ? boundaryRect.right + opts.gap : boundaryRect.left - opts.gap - width;
    var top = clamp(itemRect.top, opts.margin, Math.max(opts.margin, window.innerHeight - height - opts.margin));

    return { left: left, top: top, width: width, height: height };
  };

  HoverZoom.prototype.update = function () {
    if (!this.active || !this.pointer) return;

    var opts = this.options;
    var item = this.active.item;
    var image = this.active.image;
    var itemRect = item.getBoundingClientRect();
    var visible = image.getBoundingClientRect();

    // Imlec gorselden ciktiysa kapat (scroll sirasinda olabilir).
    if (
      this.pointer.x < visible.left ||
      this.pointer.x > visible.right ||
      this.pointer.y < visible.top ||
      this.pointer.y > visible.bottom
    ) {
      this.close();
      return;
    }

    // Panel icin yeterli yer yoksa gizle ama dinlemeye devam et (acip kapama dongusu olmasin).
    var panelRect = this.measurePanel(itemRect);
    if (!panelRect) {
      this.lens.style.display = 'none';
      this.panel.classList.remove('is-visible');
      return;
    }
    this.lens.style.display = '';
    this.panel.classList.add('is-visible');

    var rendered = renderedRect(image);
    var zoom = this.effectiveZoom(visible.width);
    var lensWidth = Math.min(panelRect.width / zoom, visible.width);
    var lensHeight = Math.min(panelRect.height / zoom, visible.height);
    var lensLeft = clamp(this.pointer.x - lensWidth / 2, visible.left, visible.right - lensWidth);
    var lensTop = clamp(this.pointer.y - lensHeight / 2, visible.top, visible.bottom - lensHeight);

    this.lens.style.width = lensWidth + 'px';
    this.lens.style.height = lensHeight + 'px';
    this.lens.style.transform =
      'translate3d(' + (lensLeft - itemRect.left) + 'px,' + (lensTop - itemRect.top) + 'px,0)';

    this.panel.style.left = panelRect.left + 'px';
    this.panel.style.top = panelRect.top + 'px';
    this.panel.style.width = panelRect.width + 'px';
    this.panel.style.height = panelRect.height + 'px';
    this.panel.style.backgroundSize = rendered.width * zoom + 'px ' + rendered.height * zoom + 'px';
    this.panel.style.backgroundPosition =
      -((lensLeft - rendered.left) * zoom) + 'px ' + -((lensTop - rendered.top) * zoom) + 'px';
  };

  var instances = [];

  window.HPHoverZoom = {
    init: function (options) {
      var start = function () {
        var root = toElement(options && options.root);
        if (!root || root.hpHoverZoom) return;
        root.hpHoverZoom = new HoverZoom(options);
        instances.push(root.hpHoverZoom);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    },
    closeAll: function () {
      instances.forEach(function (instance) {
        instance.close();
      });
    }
  };
})(window, document);
